<template>
  <div
    class="flex items-center justify-center w-7 h-7 shrink-0 rounded-full bg-brand-orange/10 dark:bg-accent-soft-dark text-brand-orange dark:text-accent-dark text-xs font-semibold"
  >
    {{ initials }}
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  name: String;
}>();

const initials = computed(() =>
  props.name
    .split(" ")
    .map((part) => part.charAt(0).toUpperCase())
    .join("")
    .slice(0, 2),
);
</script>
